export interface EmployeeAreaList {
    id: number;
    user_id: number;
    area_name: string;
}

// This feature developed by Dinesh - employee contact access permissions.
export interface ContactEmployeePermission {
    id: number;
    personal_info_id: number;
    contact_type: string;
    allow_contact: number;
    contact_list: number[];
}

export interface ContactEmployeePermissionRequestItem {
    type: "Employee" | "Professional" | "Client";
    allow_contact: 0 | 1;
    contact_ids: number[];
}

export const mapEmployeeAreaList = (data: any): EmployeeAreaList => {
    if (!data) {
        throw new Error('Invalied employee area list type')
    }

    const employeeAreaList: EmployeeAreaList = {
        id: data.id,
        user_id: data.user_id,
        area_name: data.area_name
    }
    return employeeAreaList;
}

export const mapEmployeeAreaLists = (data: any[]): EmployeeAreaList[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid employee area list data');
    }

    return data.map(mapEmployeeAreaList);
};

export interface Employee {
    contactId: number;
    contactType: string;
    contactSubType: string;

    /*Personal Info*/
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    mobile: string;
    landline: string;
    address: string;
    city: string;
    post_code: string;
    profile_image: string;
    area_list?: EmployeeAreaList[];
    contact_emp_permission: ContactEmployeePermission[];

    /*Company info*/
    companyId: number;
    personal_email: string;
    personal_phone: string;
    companyName: string;
    regno: string;
    company_email: string;
    company_phone: string;
    company_address: string;
    company_city: string;
    company_post_code: string;
    company_landline: string;

    /*Role info*/
    user_role_info_id: number;
    user_role_id: number;
    display_role_name: string;
    role_name: string;
}

export const mapEmployee = (data: any): Employee => {
    if (!data) {
        throw new Error('Invalied employee type')
    }

    const contactPermissions = Array.isArray(data.contact_emp_permission)
        ? data.contact_emp_permission
        : Array.isArray(data.personalInfo?.contact_emp_permission)
            ? data.personalInfo.contact_emp_permission
            : [];

    const employee: Employee = {
        contactId: data.contact_id,
        contactType: data.contact_type,
        contactSubType: data.contact_subtype,

        id: data.personalInfo.id,
        first_name: data.personalInfo.first_name,
        last_name: data.personalInfo.last_name,
        email: data.personalInfo.email,
        mobile: data.personalInfo.mobile,
        landline: data.personalInfo.landline,
        address: data.personalInfo.address,
        city: data.personalInfo.city,
        post_code: data.personalInfo.post_code,
        profile_image: data.personalInfo.profile_image,
        area_list: Array.isArray(data.personalInfo.area_list) ? mapEmployeeAreaLists(data?.personalInfo?.area_list) : [],
        contact_emp_permission: contactPermissions.map((permission: any) => ({
                id: permission.id,
                personal_info_id: permission.personal_info_id,
                contact_type: permission.contact_type,
                allow_contact: Number(permission.allow_contact),
                contact_list: Array.isArray(permission.contact_list)
                    ? permission.contact_list.map(Number).filter(Number.isFinite)
                    : [],
            })),

        companyId: data.CompanyInfo?.id || 0,
        personal_email: data.CompanyInfo?.personal_email || '',
        personal_phone: data.CompanyInfo?.personal_phone || '',
        companyName: data.CompanyInfo?.name || '',
        regno: data.CompanyInfo?.regno || '',
        company_email: data.CompanyInfo?.email || '',
        company_phone: data.CompanyInfo?.phone || '',
        company_address: data.CompanyInfo?.address || '',
        company_city: data.CompanyInfo?.city || '',
        company_post_code: data.CompanyInfo?.post_code || '',
        company_landline: data.CompanyInfo?.landline || '',

        user_role_info_id: data.userRoleInfo?.id || 0,
        user_role_id: data.userRoleInfo?.user_role_id || 0,
        display_role_name: data.userRoleInfo?.display_role_name || '',
        role_name: data.userRoleInfo?.role_name || '',
    }
    return employee;
}

export const mapEmployees = (data: any[]): Employee[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Employee data');
    }
    return data.map(mapEmployee);
};
